import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { partnerTypes } from "../config";
import { partnershipTypes } from "../config";
import DynamicForm from "../../../../../../components/DynamicFormTif";
import PartnerService from '../../../../../../services/PartnerService';
import { message } from "antd";

const data = {};

export default function Create({
  onClose = () => { },
  fetchData = () => { },
}) {
  const { t } = useTranslation();

  const form = useMemo(() => ({
    identification: {
      partnershipType: {
        label: t('Type of partnership'),
        type: 'select',
        position: 1,
        dataId: 'partnershipType',
        tooltip: (
          <div style={{ maxWidth: 296 }}>
            {t('Source: This partner will share information with you.')}
            <br />
            {t('Client: You will share information with this partner.')}
            <br />
            {t('Exchange: You will both share information with each other.')}
          </div>
        ),
        options: partnershipTypes.map((o) => ({ ...o, label: t(o.label) })),
        rules: [{ "required": true, "message": "errors::field is required" }],
      },
      partnerType: {
        label: t('Type of partner'),
        type: 'select',
        position: 2,
        dataId: 'partnerType',
        options: partnerTypes,
        rules: [{ "required": true, "message": "errors::field is required" }],
      },
      nickName: {
        label: {
          "partnerType is individual": t('Person name'),
          "partnerType is organisation": t('Organisation name'),
        },
        type: 'text',
        position: 3,
        showIf: 'partnerType notEmpty true',
        dataId: 'nickName',
        rules: [{ "required": true, "message": "errors::field is required" }],
      },
      invitationType: {
        label: t('Invitation type'),
        type: 'select',
        position: 3,
        dataId: 'invitationType',
        options: [
          { label: 'Email', value: 'email' },
          { label: 'Application ID', value: 'id' },
        ],
        rules: [{ "required": true, "message": "errors::field is required" }],
      },
      email: {
        label: t('Email'),
        type: 'text',
        position: 4,
        showIf: 'invitationType is email',
        dataId: 'email',
        rules: [
          { "required": true, "message": "errors::field is required" },
          { "type": "email", "message": "errors::field must be email" },
        ],
      },
      datastakeId: {
        label: t('Application ID'),
        type: 'text',
        position: 4,
        showIf: 'invitationType is id',
        dataId: 'datastakeId',
        rules: [{ "required": true, "message": "errors::field is required" }],
      },
      partnerMessage: {
        type: 'message',
        position: 4,
        label: t('If the user you are inviting is part of an existing organisation, the invitation will be shared with the account administrator of that organisation.'),
        showIf: 'partnerType is individual',
        dataId: 'partnerMessage',
      },
    },
  }), [t]);

  const submit = async (data) => {
    try {
      const { form, ...rest } = data;
      await PartnerService.create(rest);
      fetchData();
      onClose();
    } catch (err) {
      onClose();
      message.error(t(err?.response?.data?.message || 'Error occured'));
      console.log(err);
    }
  }

  return (
    <DynamicForm
      form={form}
      showSaveAndNext={false}
      data={data}
      onCancel={onClose}
      submit={submit}
    />
  );
}
